import { writeDesktopLog } from '@/lib/logger';
import { useOfflineQueueStore } from '@/state/offline-queue-store';

type QueueHandler = (payload: Record<string, unknown>) => Promise<void>;

const handlers: Partial<Record<'note.upsert' | 'task.upsert' | 'watchlist.add-company', QueueHandler>> = {};

export function registerOfflineHandler(
  key: 'note.upsert' | 'task.upsert' | 'watchlist.add-company',
  handler: QueueHandler,
) {
  handlers[key] = handler;
}

export async function flushOfflineQueue() {
  const { items, remove } = useOfflineQueueStore.getState();

  for (const item of items) {
    const handler = handlers[item.kind];
    if (!handler) {
      continue;
    }

    try {
      await handler(item.payload);
      remove(item.id);
    } catch (error) {
      await writeDesktopLog('warn', `Offline queue item ${item.kind} failed to replay.`, error);
      break;
    }
  }
}

